import { ArrowLeft } from 'lucide-react'
import React from 'react'

type ProgressBarProps = {
    progress: number // 0-100
    onBack?: () => void
    className?: string
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ progress, className = '', onBack }) => (
    <>
        <div className={`flex self-stretch justify-start items-center gap-6 ${className}`}>
            <div className="w-10 md:w-0 h-10 relative md:hidden">
                {onBack && (
                    <button
                        tabIndex={-1}
                        type="button"
                        onClick={onBack}
                        className="w-10 h-10 p-3 rounded-[96px] flex justify-center items-center gap-2 disabled:opacity-50"
                        aria-label="Back"
                    >
                        <ArrowLeft strokeWidth="2.5px" className="h-5 w-5" />
                    </button>
                )}
            </div>

            <div className="flex-1 h-2 relative">
                <div className={`relative max-w-[520px] h-2 bg-[#ECEFE9] rounded-[40px] mb-6 ${className}`}>
                    <div
                        className="absolute left-0 top-0 h-2 rounded-[40px] bg-[#C5F73C] transition-all"
                        style={{ width: `${progress}%` }}
                        aria-valuenow={progress}
                        aria-valuemin={0}
                        aria-valuemax={100}
                        role="progressbar"
                    />
                </div>
            </div>
            <div className="w-10 md:w-0 h-10 relative md:hidden" />
        </div>
    </>
)
